import StarterKit from "./StarterKit";

import Header from "./components/Header";
import NavsFull from "./components/NavsFull";
import NavsBurger from "./components/NavsBurger";

import BlockBanner from "./blocks/BlockBanner";
import BlockClient from "./blocks/BlockClient";
import BlockCollapse from "./blocks/BlockCollapse";
import BlockGallery from "./blocks/BlockGallery";
import BlockGallerySlider from "./blocks/BlockGallerySlider";
import BlockGallerySliderSimple from "./blocks/BlockGallerySliderSimple";
import BlockMap from "./blocks/BlockMap";
import BlockMovie from "./blocks/BlockMovie";
import BlockQuotes from "./blocks/BlockQuotes";
import BlockSlider from "./blocks/BlockSlider";
import BlockSliderScrollable from "./blocks/BlockSliderScrollable";
import BlockScrollingText from "./blocks/BlockScrollingText";

import Share from "./components/Share";
import BlockAnchor from "./blocks/BlockAnchor";
import BlockTextMedia from "./blocks/BlockTextMedia";
import BlockImage from "./blocks/BlockImage";
import BlockContentNavFixed from "./blocks/BlockContentNavFixed";
import BlockTextAnimated from "./blocks/BlockTextAnimated";
import BlockCaseStudies from "./blocks/BlockCaseStudies";
import BlockTabs from "./blocks/BlockTabs";
import BlockPlanComparison from "./blocks/BlockPlanComparison";
import BlockTestimonies from "./blocks/BlockTestimonies";
import ArchiveCaseStudies from "./pages/ArchiveCaseStudies";
import SingleMovie from "./pages/SingleMovie";
import ArchiveFaq from "./pages/ArchiveFaq";
import PageSubnav from "./components/PageSubnav";
import BlockTeam from "./blocks/BlockTeam";
import Lexique from "./components/Lexique";
import BlockCardSlider from "./blocks/BlockCardSlider";
import BlockHistory from "./blocks/BlockHistory";
import HighlightSearch from "./components/HighlighSearch";


window.initMap = function(){
	window.dispatchEvent(new Event('googleMapApiLoaded'));
};

document.addEventListener("DOMContentLoaded", function () {
	// Starterkit
	StarterKit.init();

	// Components
	Header.init();
	NavsFull.init();
	NavsBurger.init();
	PageSubnav.init();
	Lexique.init();
	HighlightSearch.init();

	// Blocks
	BlockAnchor.init();
	BlockBanner.init();
	BlockCardSlider.init();
	BlockCaseStudies.init();
	BlockClient.init();
	BlockContentNavFixed.init();
	BlockCollapse.init();
	BlockHistory.init();
	// BlockGallery.init();
	// BlockGallerySlider.init();
	// BlockGallerySliderSimple.init();
	// BlockMap.init();
	BlockImage.init();
	BlockMovie.init();
	// BlockQuotes.init();
	BlockSlider.init();
	// BlockScrollingText.init();
	// BlockSliderScrollable.init();
	BlockTeam.init();
	BlockTestimonies.init();
	BlockTextAnimated.init();
	BlockTextMedia.init();
	BlockTabs.init();
	BlockPlanComparison.init();

	ArchiveCaseStudies.init();
	SingleMovie.init();
	ArchiveFaq.init();

	Share.init();
});
